var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-table table-fixed-left"},[_c('div',{staticClass:"c-table-header"},[_c('div',{staticClass:"c-tr",style:({ height: _vm.thH + 'px' })},_vm._l((_vm.columns),function(item){return _c('div',{key:item.key,staticClass:"c-th",style:({
          width: item.width + 'px',
          flex: item.width ? 'none' : 1,
          textAlign: item.align || 'left',
          lineHeight: _vm.thH - 20 + 'px',
        })},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)]),(_vm.dataSource.length > 0)?_c('div',{staticClass:"c-table-body"},_vm._l((_vm.dataSource),function(row,index){return _c('div',{key:index,staticClass:"tr-box",class:_vm.showEven ? 'tr-box-even' : ''},[_c('div',{staticClass:"tr",style:({ height: _vm.rowH })},_vm._l((_vm.columns),function(col){return _c('div',{key:index + col.key,staticClass:"c-td",class:[
            {
              ellipsis: col.textOverflow === 'ellipsis',
              auto: col.textOverflow !== 'ellipsis',
            },
          ],style:({
            width: col.width + 'px',
            flex: col.width ? 'none' : 1,
            textAlign: col.align || 'left',
            color: row.color || '#1D2129',
          })},[_c('span',{style:(row[`${col.key}Style`]),attrs:{"title":row[col.key]}},[_vm._v(" "+_vm._s(row[col.key] || "--"))]),_vm._t("name",null,{"columnName":col.key,"row":row})],2)}),0)])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }